import { formatTime } from "../lib/format";

/**
 * Штамп «в работе у …» — ОДИН на все экраны (D-24, замечание приёмки 18.08.2026).
 *
 * ПОЧЕМУ НЕ ССЫЛОЧНЫМ СИНИМ, как было сделано сначала. `accent` — цвет НАЖИМАЕМОГО: им набраны
 * ссылки, активная навигация и primary-кнопки. В списке черновиков этой же краской набраны имена
 * файлов, ведущие на карточку, и строка «в работе у Петрова» вставала с ними в один ряд: глаз
 * читал её как ещё одну ссылку и искал, куда нажать. Нажимать там нечего — это СОСТОЯНИЕ объекта,
 * такое же, как «Готов к верификации» или «Ошибка».
 *
 * Поэтому цвет взят из ряда состояний (`control-fg` на `control-bg` — «на контроле»), а форма —
 * из общего класса `.stamp`, которым набраны все прочие штампы. Контраст этой пары считает сторож
 * палитры (`styles/tokens.test.ts`, порог WCAG AA 4,5:1), а не глаз разработчика.
 *
 * ОТДЕЛЬНЫМ КОМПОНЕНТОМ, А НЕ ТРЕМЯ ОДИНАКОВЫМИ ФРАГМЕНТАМИ: надпись встречается в очереди
 * верификации, в карточке черновика и в «Регистрации» у отправителя. Ровно так она и разъехалась
 * бы — один экран поправили, два забыли, и «в работе» на них осталось бы ссылкой.
 */
export function InWorkStamp({
  name,
  since,
  you = false,
}: {
  /** Имя держателя; игнорируется при `you`. */
  readonly name: string | null;
  /** Момент захвата или последней активности; `null` — время не показываем. */
  readonly since: string | null;
  /** Черновик держит сам смотрящий — «Вы» вместо имени. */
  readonly you?: boolean;
}) {
  // ФОРМА БЕЗ ПАДЕЖА — «В работе — Петров П. П., с 17:11» (решение владельца 18.08.2026).
  //
  // Напрашивалось «в работе У Петрова», но фамилию пришлось бы склонять, а склонение русских
  // фамилий программно ненадёжно: «у Петров П. П.» читается как ошибка системы, а «у Дюма» и
  // «у Кузьмичей» ломают любое простое правило. Тире ставит имя в именительный падеж, и надпись
  // остаётся верной для любой фамилии — включая те, которых мы не предвидели.
  const who = you ? "Вы" : (name ?? "другой юрист");
  const when = since === null ? "" : `, с ${formatTime(since)}`;
  return (
    <span className="stamp bg-control-bg text-control-fg">
      В работе — {who}
      {when}
    </span>
  );
}
